import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import _ from 'lodash';

export function AffiliationNewHubRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.AffiliationNewHub', {
		url: '/admin/account/hubs/new',
		controllerAs: 'vm',
		controller: AffiliationNewHubCtrl,
		templateUrl: '/ng/hub/Account/Hub/AccountHubCtrl.html?' + window.BUILD,
		permission: ['manage_hubs'],
		resolve: {
			$title: () => 'New Hub :: Account Admin',
			themes: ApiResourcify.endpoint('/affiliations/themes'),
			languages: ApiResourcify.endpoint('/nosql/languages'),
		},
	});
}

export class AffiliationNewHubCtrl {
	constructor(Api, Identity, Theme, themes, languages) {
		'ngInject';
		// save injections
		this.Api = Api;
		this.themes = themes;
		this.languages = languages;
		// setup
		this.accountChoices = Identity.accountChoices();
		this.baseUrl = window.BASE_URL;
		this.isSuperadmin = Identity.isSuperadmin();
		this.mode = 'add';
		this.languageLookup = {};
		languages.forEach(language => {
			this.languageLookup[language.code] = language.label;
		});
		this.client = {
			name: '',
			client_theme_id: Theme.data().id,
			affiliation: _.find(this.accountChoices, { id: Identity.currentClient().account_id }),
			language: 'englishadvanced',
		};
		this.setLoginUrl();
		this.decideEmailDomain();
	}

	decideEmailDomain() {
		const isSpecialDomain = /^(sharprstag\.com|sharprua\.com|sharprci\.com|sharpr\.de|sbuxinsightsportal\.com)$/.test(
			window.location.hostname
		);
		// Note: at this time, even cultureforbreakfast.com and cspacepulse.com
		// have email submissions through sharpr.com
		this.emailDomain = isSpecialDomain ? window.location.hostname : 'sharpr.com';
	}

	setLoginUrl() {
		const currentTheme = _.find(this.themes, { id: this.client.client_theme_id });
		this.loginUrl = currentTheme && currentTheme.login_url ? currentTheme.login_url : '';
	}

	setSubmissionEmail() {
		this.client.inbox_user = (this.client.name + '').toLowerCase().replace(/[^\w.-]/g, '');
	}

	saveHub() {
		let data = {
			name: this.client.name,
			client_theme_id: this.client.client_theme_id,
			affiliation_id: this.client.affiliation.id,
			language: this.client.language,
			inbox_user: this.client.inbox_user + '@' + this.emailDomain,
		};
		this.Api.create('/clients', data).then(
			() => {
				this.$resolve();
			},
			() => {}
		);
	}
}
